<div style="margin-bottom: 20px ;">
  <app-progress-bar [indexItem]=itemNumber [progressBarState]=progressBarName [progressBarArray1]=progressBarArray1>
  </app-progress-bar>
</div>


<div *ngIf="!fromTable" class="section">
    <div class="content" style="margin: 10px 16px">
      <p class="sub-text-600-bold" style="display: inline-block;margin-top: 10px;">Extract Batch Key From Cloud</p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
      <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
        <p class="text_12">New Batch Key</p>
        <p *ngIf="!batchKey" class="text_14">Submit saved configurations to generate a New Batch Key</p>
        <p *ngIf="batchKey" class="text_14">{{batchKey}}</p>
      </div>
      <div *ngIf="batchKey"
        style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
        <p class="text_12">Status</p>
        <p *ngIf="batchKey" class="text_14">New </p>
      </div>
      <div style="display: inline-block;margin-left: 20px;">
        <label class="text_12" style="display: block;margin-bottom: 10px;">Cloud Instance <span
            style="color: red;">*</span></label>
        <select class="select-css" [(ngModel)]="selectedInstance" name="instanceName"
          (change)="onInstanceChange(selectedInstance)" disabled>
          <option [ngValue]="null">Select</option>
          <option *ngFor="let instance of instanceList" [ngValue]="instance">{{instance.INSTANCE}}</option>
        </select>
      </div>      
      <button mat-flat-button class="green-button" style="float: right;min-width: 120px; margin-top: 30px;"
        (click)="onSubmitParams()">
        Submit Parameters</button>
    </div>
  
  
    <div class="content" style="margin: 0px 16px;">
      <div *ngFor="let item of trackNewObj; let i = index" (click)="showArray[i]=!showArray[i]"
        style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
        <span>
          <span *ngIf="!showArray[i]"><img alt="image" src="./assets/Expand-Column.svg"
              class="expand-button"></span>
          <span *ngIf="showArray[i]"><img alt="image" src="./assets/Expand-Column-svg.svg"
              class="expand-button"></span><button mat-button>{{item}}</button>
        </span>
        <div *ngIf="showArray[i]" class="buttons-i">          
            <ng-container *ngFor="let configItem of configData" >
              <div  *ngIf="item == configItem.TRACK && configItem.saveStatus" style="margin-bottom: 15px;">
              <h3 style="font-size: 16px;font-weight:500;margin:0px 0px 5px !important">{{configItem.APPLICATION}}</h3>
              <ng-container *ngFor="let task of configItem.TASK, index as i" >
              <div *ngIf="task.selectStatus == 'y'" style="margin-left: 10px;display: inline-block;width: 48%;">
              <mat-checkbox (click)="paramsPopup($event, task,i,configItem.APPLICATION)"  [checked]="task.checked"  [disabled]="task.EXTRACTPARAMETER == 'N'"
                [disableRipple]="true" (click)="$event.preventDefault()">
                <span bat-button>{{task.TASK_NAME}}</span>
              </mat-checkbox>
          </div>
              </ng-container>
            </div>
            </ng-container>  
        </div>
      </div>
    </div>
  </div>



  <div *ngIf="fromTable" class="section">
    <div class="content" style="margin: 10px 16px">
      <p class="sub-text-600-bold" style="display: inline-block;margin-top: 10px;">Extract Batch Key From Cloud</p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
      <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
        <p class="text_12">New Batch Key</p>
        <p *ngIf="!batchKey" class="text_14">Submit saved configurations to generate a New Batch Key</p>
        <p *ngIf="batchKey" class="text_14">{{batchKey}}</p>
      </div>
      <div *ngIf="batchKey"
        style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
        <p class="text_12">Status</p>
        <p *ngIf="batchKey" class="text_14">New </p>
      </div>
      <div style="display: inline-block;margin-left: 20px;">
        <label class="text_12" style="display: block;margin-bottom: 10px;">Cloud Instance <span
            style="color: red;">*</span></label>
        <select class="select-css" [(ngModel)]="selectedInstance" name="instanceName"
          (change)="onInstanceChange(selectedInstance)" disabled>
          <option [ngValue]="null">Select</option>
          <option *ngFor="let instance of instanceList" [ngValue]="instance">{{instance.INSTANCE}}</option>
        </select>
      </div>      
      <button mat-flat-button class="green-button" style="float: right;min-width: 120px; margin-top: 30px;"
        (click)="onSubmitParams()">
        Submit Parameters</button>
    </div>
  
  
    <div class="content" style="margin: 0px 16px;">
      <div *ngFor="let item of trackNewObj; let i = index" (click)="showArray[i]=!showArray[i]"
        style="border-bottom: 1px solid #c4c4c4; padding-top: 10px; padding-bottom: 10px;">
        <span>
          <span *ngIf="!showArray[i]"><img alt="image" src="./assets/Expand-Column.svg"
              class="expand-button"></span>
          <span *ngIf="showArray[i]"><img alt="image" src="./assets/Expand-Column-svg.svg"
              class="expand-button"></span><button mat-button>{{item}}</button>
        </span>
        <div *ngIf="showArray[i]" class="buttons-i">          
            <ng-container *ngFor="let configItem of batchKeyDetails" >
              <div  *ngIf="item == configItem.track && configItem.saveStatus" style="margin-bottom: 15px;">
              <h3 style="font-size: 16px;font-weight:500;margin:0px 0px 5px !important">{{configItem.application}}</h3>
              <ng-container *ngFor="let task of configItem.linedetail, index as i" >
              <div *ngIf="task.taskselected == 'Y'" style="margin-left: 10px;display: inline-block;width: 48%;">
              <mat-checkbox (click)="paramsPopupEdit($event, task,i,configItem.application)"  [checked]="task.checked"  [disabled]="task.EXTRACTPARAMETER == 'N'"
                [disableRipple]="true" (click)="$event.preventDefault()">
                <span bat-button>{{task.taskname}}</span>
              </mat-checkbox>
          </div>
              </ng-container>
            </div>
            </ng-container>  
        </div>
      </div>
    </div>
  </div>